import React from "react";
import PropTypes from "prop-types";
import { InputNumber } from "antd";
import cx from "classnames";
import "styles/search-filter.css";

const Component = ({
    setSelectedKeys,
    selectedKeys = [
        {
            min: null,
            max: null
        }
    ],
    confirm,
    filterOverrideClassName
}) => {
    let minInput = null,
        maxInput = null;
    return (
        <div
            className={cx("custom-filter-dropdown", filterOverrideClassName)}
            onFocus={e => e.stopPropagation()}
        >
            <InputNumber
                ref={node => (minInput = node)}
                placeholder="min"
                value={selectedKeys[0] ? selectedKeys[0].min : null}
                parser={value => value.replace(/\s?|(,*)/g, "")}
                onClick={e => {
                    e.stopPropagation();
                    minInput.focus();
                }}
                onChange={e => {
                    setSelectedKeys([
                        {
                            min: e,
                            max: selectedKeys[0] ? selectedKeys[0].max : null
                        }
                    ]);
                }}
                onPressEnter={confirm}
                onBlur={confirm}
            />
            <InputNumber
                ref={node => (maxInput = node)}
                placeholder="max"
                value={selectedKeys[0] ? selectedKeys[0].max : null}
                parser={value => value.replace(/\s?|(,*)/g, "")}
                onClick={e => {
                    e.stopPropagation();
                    maxInput.focus();
                }}
                onChange={e => {
                    setSelectedKeys([
                        {
                            min: selectedKeys[0] ? selectedKeys[0].min : null,
                            max: e
                        }
                    ]);
                }}
                onPressEnter={confirm}
                onBlur={confirm}
            />
        </div>
    );
};
Component.displayName = "TableSearchFilterDropdown";
Component.propTypes = {
    setSelectedKeys: PropTypes.func,
    confirm: PropTypes.func,
    clearFilters: PropTypes.func,
    selectedKeys: PropTypes.any,
    filterOverrideClassName: PropTypes.string
};
export default Component;
